import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';

import {
  doFetchProductDetails,
  doAddToCart,
  doFetchVintageDetails,
  getRecommendedProduct,
} from '../../actions/productAction';
import {
  doPostKredivoAvailableInstallments,
  doPostAkulakuAvailableInstallments,
} from '../../actions/paymentAction';
import {
  doFetchProvinces,
  getHistoryShipping,
} from '../../actions/postalCodeAction';
import { doFetchHighestOffer } from '../../actions/offerAction';
import { doFetchProfile, doFetchCurrencyRate } from '../../actions/authAction';

// IMPORT COMPONENT
import RelatedSneakerSection from './RelatedSneakers';
import Details from './Details';
import CheckoutPage from './CheckoutPage';
import withScrollTo from '../hoc/withScrollTo';
import MakeOfferPage from './MakeOfferPage';
import OfferLive from './OfferLive';

// IMPORT MODAL
import { ModalLineInfo } from '../Modals';

// IMPORT HELPERS
import Analytics from '../../services/Analytics';
import { API_BASE_URL, CURRENCY_CODE } from '../../constants';
import { joinClassnames } from 'helpers/classNames';
import axios from 'axios';

const NOT_FOUND_PAGE = '/404';

class PageProductDetailsV2 extends React.Component {
  constructor(props) {
    super(props);

    const isParamsChecking = this.props.location.search
      ? this.props.location.search
      : this.props.location.pathname;

    // const isPreVerified = isParamsChecking.includes("pre_verified=true") ? true : "";
    const isVintage = isParamsChecking.includes('vintage=true') ? true : false;
    const isCollectionPage = isParamsChecking.includes('?collection')
      ? true
      : false;
    const isFromSearch = isParamsChecking.includes('from=search');
    const isFromHotProducts = isParamsChecking.includes('from=hot-products');
    const isFromHomePage = isParamsChecking.includes('from=home');
    // const collectionSlug = !isPreVerified ? this.props.location.pathname.split('?collection=')[1] : this.props.location.pathname.split('?collection=')[1].split('&')[0];

    const queries = new URLSearchParams(this.props.location.search);
    const collectionSlug = queries.get('collection'); //hypebrands if collection=hypebrands. if no collection in query params, the value is null
    const isPreVerified = queries.get('express_shipping'); //checking if there is pre_verified in query params or not. if not, the value is null
    const idCollection = queries.get('collection_id'); //hypebrands if collection=hypebrands. if no collection in query params, the value is null

    this.state = {
      productId: this.props.match.params.id,
      isProductDetailLoading: true,
      slug: this.props.match.params.slug,
      withDefaultSelected: false,
      product: {},
      selectedSize: null,
      availableSizes: [],
      usedSizes: [],
      preOrderSizes: [],
      vintageList: [],
      sizeCollapse: 'NEW',
      modalLineOpen: false,
      isPreVerified,
      isVintage,
      dataProductInProgress: {
        dataInprogress: {},
        isFromDetail: false,
        allParentProps: {},
      },
      isHideAllDetails: false,
      isCollectionHero: this.props.location.isCollectionHero,
      isCollectionPage,
      collectionSlug,
      collection_id: idCollection ? parseInt(idCollection) : null,
      brandName: '',
      isFromHomePage,
      isFromSearch,
      isFromHotProducts,
    };
    this._handleSizeChanged = this._handleSizeChanged.bind(this);
    this._handleSizeCollapseChanged =
      this._handleSizeCollapseChanged.bind(this);
    this._handleCheckout = this._handleCheckout.bind(this);
    this._onToggle = this._onToggle.bind(this);
    this.setHideAllDetails = this.setHideAllDetails.bind(this);
    // this._handleOffer = this._handleOffer.bind(this);
  }

  //  useQuery = () => {
  //     return new URLSearchParams(this.props.location?.search);
  //  }

  saveActivity = async (params) => {
    const { isCollectionPage, isFromHomePage, isFromSearch, isFromHotProducts } =
      this.state;

    if (!params) {
      return;
    }

    if (!params.userId || !params.productVariantId) {
      return;
    }

    const getAction = () => {
      if (isCollectionPage) {
        return 'PRODUCT_COLLECTION_ITEM_CLICK';
      }

      if (isFromHomePage) {
        return 'MARKET_ITEM_CLICK';
      }

      if (isFromSearch) {
        return 'SEARCH_RESULTS_ITEM_CLICK';
      }

      if (isFromHotProducts) {
        return 'EDITORS_PICK_ITEM_CLICK';
      }

      return null;
    };

    const action = getAction();
    
    if (!action) {
      return;
    }

    const payload = {
      product_variant_id: params.productVariantId,
      action,
      app_os: 'Web',
      user_id: params.userId,
    };

    const result = await axios
      .post(`${API_BASE_URL}/products/detail/activity`, payload)
      .then((res) => {
        const responseData = res.data;

        if (responseData.status_code !== 200) {
          return {
            isSuccess: false,
            message: responseData.message,
            data: responseData.data,
          };
        }

        return {
          isSuccess: true,
          message: responseData.message,
          data: responseData.data,
        };
      })
      .catch((err) => {
        return {
          isSuccess: false,
          message: 'Action Failed',
          data: null,
        };
      });
  };

  async componentDidMount() {
    window.gtag_repport_product_details();
    // this.getCollectionIdFromUrl(this.props?.location?.search ?? ''); // get collection id
    const { history } = this.props;
    const { isPreVerified, isVintage, isCollectionPage, collectionSlug } =
      this.state;
    let productVariantId;
    let params = {};
    if (collectionSlug) {
      params['collection'] = collectionSlug;
    }
    if (isPreVerified) {
      params['pre_verified'] = isPreVerified;
    }

    if (isVintage) {
      await this.props.doFetchVintageDetails(this.state.slug).then((res) => {
        productVariantId = res?.value?.data?.id;
      });
    } else if (isCollectionPage) {
      await this.props
        .doFetchProductDetails(this.state.slug, params)
        .then((res) => {
          productVariantId = res?.value?.data?.id;
        });
    } else {
      await this.props
        .doFetchProductDetails(this.state.slug, params)
        .then((res) => {
          productVariantId = res?.value?.data?.id;
        });
    }

    this.props.doFetchProvinces();
    this.props.getHistoryShipping();
    if (this.props.dataAuth.isLogged) {
      this.props.doFetchProfile().then((res) => {
        const profile = res?.value?.data;
        if (profile) {
          this.saveActivity({
            userId: profile.id,
            productVariantId,
          });
        }
        try {
          let code = res.value.data.country_code;
          const currencyCode = CURRENCY_CODE[code === 'IDN' ? 'IDN' : 'ETC'];
          this.props.fetchCurrencyRate(currencyCode);
        } catch (error) {
          this.props.fetchCurrencyRate(CURRENCY_CODE['IDN']);
        }
      });
    }
    // this.props.doFetchHighestOffer(this.state.productId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.dataProduct.isFetch === false &&
      nextProps.dataProduct.isFetch !== this.props.dataProduct.isFetch &&
      nextProps.dataProduct.status_code === 200
    ) {
      const { sex, availables, pre_orders, useds, listings, ...rest } =
        nextProps.dataProduct;
      const { slug, productId } = this.state;
      // Validate if id and slug from params match with nextprops
      if ((productId != rest.id || slug != rest.slug) && !productId)
        this.props.history.replace(NOT_FOUND_PAGE);
      const lastState = { ...this.state };
      lastState.product = { ...rest, sex };

      if (listings) {
        lastState.vintageList = listings;
      } else {
        // const availableSizesSorted = availables.sort(
        //   (a, b) => parseFloat(a.asking_price) - parseFloat(b.asking_price),
        // );
        // console.log('availableSizesSorted', availableSizesSorted)
        // const preOrderSizesSorted = pre_orders.sort(
        //   (a, b) => parseFloat(a.asking_price) - parseFloat(b.asking_price),
        // );
        // const usedSizesSorted = useds.sort(
        //   (a, b) => parseFloat(a.asking_price) - parseFloat(b.asking_price),
        // );
        // lastState.availableSizes = availableSizesSorted;
        // lastState.preOrderSizes = preOrderSizesSorted;
        // lastState.usedSizes = usedSizesSorted;

        // if (!availableSizesSorted.length && usedSizesSorted.length)
        //   // Sugested Mbak Sarah begini.
        //   lastState.sizeCollapse = 'USED';
        // else if (!availableSizesSorted.length && preOrderSizesSorted.length)
        //   lastState.sizeCollapse = 'PO';

        lastState.availableSizes = availables;
        lastState.preOrderSizes = pre_orders;
        lastState.usedSizes = useds;

        if (!availables.length && useds.length)
          // Sugested Mbak Sarah begini.
          lastState.sizeCollapse = 'USED';
        else if (!availables.length && pre_orders.length)
          lastState.sizeCollapse = 'PO';
      }

      if (lastState.selectedSize) {
        const amount = parseInt(lastState.selectedSize.asking_price);
        const prod = {
          id: rest.id,
          user_sell_id: lastState.selectedSize.id,
          name: rest.display_name,
          price: amount,
          quantity: 1,
        };
        this.props.doGetKredivoInstallments(prod, amount);
        this.props.doGetAkulakuInstallments(prod);
        // this.props.doFetchHighestOffer(this.state.productId);
      }
      this.setState({ ...lastState, isProductDetailLoading: false });
    } else if (nextProps.dataProduct.error != null) {
      const { error } = nextProps.dataProduct;
      if (error.status_code === 500 || error.status_code === 404)
        this.props.history.replace(NOT_FOUND_PAGE);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.url != this.props.match.url &&
      this.props.match.params.id
    )
      this.setState({ isProductDetailLoading: true }, () => {
        const { isVintage } = this.state;
        let params = {};

        if (isVintage) {
          this.props.doFetchVintageDetails(this.props.match.params.slug);
        } else {
          const queries = new URLSearchParams(this.props.location.search);
          const isPreVerified = queries.get('express_shipping'); //checking if there is pre_verified in query params or not. if not, the value is null
          if (isPreVerified) {
            params = {
              pre_verified: isPreVerified,
            };
          }
          this.props.doFetchProductDetails(
            this.props.match.params.slug,
            params,
          );
        }
      });

    if (
      this.props.dataAuth.userdata.id &&
      prevProps.dataAuth.userdata.id !== this.props.dataAuth.userdata.id
    ) {
      const { isLogged, userdata = {} } = this.props.dataAuth || {};

      if (isLogged) {
        this.props.getRecommendedProduct(userdata.id);
      }
    }

    if (
      !this.props.dataProduct.isFetch &&
      prevProps.dataProduct.isFetch != this.props.dataProduct.isFetch
    ) {
      this.setState({
        productId: this.props.dataProduct?.id,
      });
    }
  }

  // getCollectionIdFromUrl(url = '') {
  //   try {
  //     const splitUrl = url.split('?');
  //     const filterCollectionId = splitUrl?.forEach((str) => {
  //       if (str?.includes('collection_id')) {
  //         const collection_id = Number(str?.split('=')?.[1] ?? '0');
  //         console.log('===COLLECTION ID', collection_id);
  //         this.setState({
  //           collection_id,
  //         });
  //       }
  //     });
  //   } catch (err) {
  //     console.log('ERROR PageProductDetailsTPO', err);
  //     this.setState({
  //       collection_id: null,
  //     });
  //   }
  // }

  setHideAllDetails(params) {
    this.setState({
      isHideAllDetails: params,
    });
  }

  _onToggle() {
    this.setState({ modalLineOpen: !this.state.modalLineOpen });
  }

  _handleSizeChanged(selectedSize, rewriteUrl = false) {
    this.setState({ selectedSize }, () => {
      const { asking_price, id, box_condition, size_id, size } = selectedSize;
      const { product } = this.state;

      if (rewriteUrl) {
        const stringed = queryString
          .stringify({ box_condition, x: id, size_id, size: size.US })
          .toLocaleLowerCase();
        this.props.doAddToCart({
          product: { ...this.state._product },
          user_sell: selectedSize,
        });
        this.props.history.replace({
          pathname: `${this.props.match.url}/checkout`,
          search: stringed,
        });
      }
      const prod = {
        id: product.id,
        user_sell_id: id,
        name: product.display_name,
        price: parseInt(asking_price),
        quantity: 1,
      };

      this.props.doGetKredivoInstallments(prod, parseInt(asking_price));
      this.props.doGetAkulakuInstallments(prod);
      // this.props.doFetchHighestOffer(this.state.productId);
    });
  }

  _handleSizeCollapseChanged(sizeCollapse) {
    this.setState({ sizeCollapse, selectedSize: null });
  }

  _handleCheckout() {
    const { ...details } = this.state.product;
    const { selectedSize } = this.state;

    if (selectedSize) {
      const { box_condition, id, size_id, size, asking_price } = selectedSize;

      let stringed = queryString
        .stringify({ box_condition, x: id, size_id, size: size.US })
        .toLocaleLowerCase();
      this.props.doAddToCart({
        product: { ...details },
        user_sell: selectedSize,
      });
      this.props.history.push({
        pathname: `${this.props.match.url}/checkout`,
        search: stringed,
      });

      const display_name = this.state.product.display_name;
      const SKU = this.state.product.SKU;
      const category = this.state.product.product.category.name;
      const product_id = this.state.product.product_id;
      const sell = this.state.selectedSize;

      Analytics.recordAddToCart(
        display_name,
        category,
        SKU,
        'product',
        asking_price,
        'IDR',
        sell.id,
        sell.user_id,
      );
    }
  }

  _handleGoBack = () => {
    this.props.history.replace(
      `/${this.props.dataCategory}/${this.state.brandName}/${this.state.slug}`,
    );
  };

  _renderMetaTag = () => {
    const { display_name, meta, details } = this.props.dataProduct;
    const regex = /(<([^>]+)>)/gi;
    const description = details ? details.replace(regex, '') : '';

    if (meta) {
      return (
        <Helmet>
          <title>{meta.title}</title>
          <meta
            name="description"
            content={meta.description}
            data-react-helmet="true"
          />
        </Helmet>
      );
    }

    if (display_name) {
      return (
        <Helmet>
          <title>{display_name} | Kick Avenue</title>
          {description !== '' && (
            <meta
              name="description"
              content={description}
              data-react-helmet="true"
            />
          )}
        </Helmet>
      );
    }

    return <div />;
  };

  handleDataInProcess = (dataInprogress, allParentProps, status) => {
    this.setState({
      dataProductInProgress: {
        dataInprogress,
        isFromDetail: true,
        allParentProps,
      },
    });

    status === 'buy-now'
      ? this._handleCheckout()
      : this.props.history.push(`${this.props.match.url}/${'offer'}`);
  };

  render() {
    const { isFromDetail } = this.state.dataProductInProgress;

    return (
      <div
        className={joinClassnames(
          'page-container',
          this.props.countdown_active ? 'is-countdown-active' : '',
        )}
        id="new-product-detail-container"
      >
        <Switch>
          <Route
            exact
            path={`${this.props.match.url}/checkout`}
            render={(props) => (
              <CheckoutPage
                dataProductInProgress={this.state.dataProductInProgress}
                collection_id={this.state.collection_id}
              />
            )}
          />
          <Route
            exact
            path={`${this.props.match.url}/offer`}
            render={(props) => (
              <MakeOfferPage
                dataProductInProgress={this.state.dataProductInProgress}
                collection_id={this.state.collection_id}
              />
            )}
          />
          <Route
            exact
            path={`${this.props.match.url}/offer/live`}
            render={(props) => <OfferLive />}
          />
          <Route
            render={(props) => {
              const {
                match,
                history,
                dataAuth,
                dataCart,
                getHistoryShipping,
                dataPostalCode,
                dataProvinces,
              } = this.props;

              const {
                availableSizes = [],
                isProductDetailLoading,
                product,
                selectedSize = [],
                usedSizes,
                preOrderSizes = [],
                vintageList,
                sizeCollapse,
                dataKredivo,
                productId,
                slug,
                modalLineOpen,
                isHideAllDetails,
              } = this.state;

              const start_from_price = ((data) => {
                Array.min = function (array) {
                  if (array.length === 0) return 0;

                  const askings = array.map((item) =>
                    item.total_subsidy
                      ? +item.total_subsidy
                      : +item.asking_price,
                  );

                  return +Math.min.apply(Math, askings);
                };
                return Array.min(data);
              })(
                this.state.isVintage
                  ? [...vintageList]
                  : [...availableSizes, ...usedSizes, ...preOrderSizes],
              );

              const propsFromDetailSectionParent = {
                availableSizes,
                product,
                selectedSize,
                usedSizes,
                preOrderSizes,
                dataProvinces,
                productId,
                slug,
                vintageList,
                sizeCollapse,
                dataAuth,
                dataCart,
                history,
                currentURL: match,
                dataInstallments: dataKredivo,
                allow: dataAuth.isLogged,
                dataAddress: dataPostalCode.shippingHistory,
                start_from_price,
                isHideAllDetails,
                onSizeChanged: this._handleSizeChanged,
                onSizeCollapseChanged: this._handleSizeCollapseChanged,
                onBuy: this._handleCheckout,
                onModalLine: this._onToggle,
                handleDataInProcess: this.handleDataInProcess,
                onGetHistoryShipping: getHistoryShipping,
                onRedirectBack: this._handleGoBack,
                setHideAllDetails: this.setHideAllDetails,
              };

              return (
                <>
                  {this._renderMetaTag()}
                  <ModalLineInfo
                    isOpen={modalLineOpen}
                    onToggle={this._onToggle}
                  />
                  <Details
                    propsForDetailSection={propsFromDetailSectionParent}
                  />
                  {!isHideAllDetails && (
                    <RelatedSneakerSection isLoading={isProductDetailLoading} />
                  )}
                </>
              );
            }}
          />
        </Switch>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    dataProduct: state.dataProduct.productDetails,
    dataKredivo: state.dataPayment.kredivoAvailableInstallment,
    dataAuth: state.dataAuth,
    dataPostalCode: state.dataPostalCode,
    dataProvinces: state.dataPostalCode.provinces,
    dataOffer: state.dataOffer,
    dataCategory: state.dataCategory.selected,
    countdown_active: state.dataMenu.countdown_modal,
    state,
  };
};

const mapDistpatchToProps = (dispatch) => {
  return {
    doFetchProductDetails: (productId, params) =>
      dispatch(doFetchProductDetails(productId, params)),
    doAddToCart: (payload) => dispatch(doAddToCart(payload)),
    doGetKredivoInstallments: (product, amount) =>
      dispatch(doPostKredivoAvailableInstallments(product, amount)),
    doGetAkulakuInstallments: (product) =>
      dispatch(doPostAkulakuAvailableInstallments(product)),
    doFetchProvinces: () => dispatch(doFetchProvinces()),
    getHistoryShipping: () => dispatch(getHistoryShipping()),
    doFetchHighestOffer: (productId) =>
      dispatch(doFetchHighestOffer(productId)),
    doFetchVintageDetails: (productId) =>
      dispatch(doFetchVintageDetails(productId)),
    getRecommendedProduct: (userId) => dispatch(getRecommendedProduct(userId)),
    doFetchProfile: () => dispatch(doFetchProfile()),
    fetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),
  };
};

const reduxConnect = connect(mapStateToProps, mapDistpatchToProps);

export default withRouter(reduxConnect(withScrollTo(PageProductDetailsV2)));
